import { useState, useEffect } from "react";
//#region types
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
//#region components
import { useBusinessUnitService } from "serviceHooks";
//#endregion

function useBusinessUnitAutoComplete() {
  const businessUnitService = useBusinessUnitService();
  const [allBusinessUnits, setAllBusinessUnits] = useState<AutocompleteListItem[]>([]);

  useEffect(() => {
    businessUnitService.searchBusinessUnitsAutoComplete().then((result) => setAllBusinessUnits(result));
  }, []);

  return (searchStr: string): AutocompleteListItem[] =>
    allBusinessUnits.filter((bu) => bu.value.toLowerCase().includes(searchStr.toLowerCase()));
}

export default useBusinessUnitAutoComplete;
